import { useEffect, useState } from 'react';
import { Trans } from '@lingui/macro';
import { ActionIcon, LoadingOverlay, Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'tabler-icons-react';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { apiClient } from '../../core/libs/api';
import { HttpResource } from '../../core/libs/http-resource';
import { logoutRequest } from '../../domains/auth/requests/logout.request';
import { AppNotify } from '../../features/app-notify/app-notify';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';

import styles from './logout.page.module.css';

export const LogoutPage = () => {
  const navigate = useNavigate();

  const [logoutReq] = useState(
    () =>
      new HttpResource<void, any>({
        apiClient,
        httpRequest: logoutRequest,
        errorNotify: new AppNotify(),
        onFinish() {
          window.location.assign('/');
        },
      })
  );

  useEffect(() => logoutReq.send(), [logoutReq]);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.backButton}>
          <ActionIcon
            variant="transparent"
            radius="50%"
            size="40px"
            bg="transparent"
            onClick={() => navigate('/')}
          >
            <ArrowLeft size={24} strokeWidth={2} color="white" />
          </ActionIcon>
        </div>
        <div className={styles.routeTitle}>
          <h1 className={styles.headerTitle}>
            <Trans>Личный кабинет</Trans>
          </h1>
        </div>
        <div className={styles.mainSideMenu}>
          <MainSideMenu />
        </div>
      </header>

      <main className={styles.main}>
        <UiCard>
          <Text>
            <Trans>Выполняется выход из приложения...</Trans>
          </Text>
          <LoadingOverlay visible={true}></LoadingOverlay>
        </UiCard>
      </main>
    </div>
  );
};
